import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IMainMenu } from '@interfaces';
import { BehaviorSubject } from 'rxjs';
import { ACCESS_ROLES } from '@shared';

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  private jsonUrl = 'assets/access_roles.json';
  public sidebarClose: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    window.innerWidth < 766 ? true : false
  );

  constructor(private http: HttpClient) {}

  public getAccessRoles(accessLevel: string): IMainMenu[] {
    return ACCESS_ROLES[accessLevel];
  }

  public getEligibilityMenus(accessLevel: string) {
    const menus = ACCESS_ROLES[accessLevel];
    const benefitMenus = (menus || []).find(
      (x) => x.name === 'Benefit Tools'
    )?.menus;
    const eligibilityMenus = benefitMenus.find(
      (x) => x.key === 'online-eligibility'
    )?.subFeatures;
    return eligibilityMenus;
  }
}
